import { FC, PropsWithChildren } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { MembershipWithOrganizationTypeEnum } from '@/api/rest/resources/types/membership';
import { useUser } from '@/lib/auth';
import { paths } from '@/routing';
import { RequireAuth } from '@/routing/components/protections/require-auth/RequireAuth';
import { RequireOnboarding } from '@/routing/components/protections/require-onboarding/RequireOnboarding';

export const BuyerSignedInRoute: FC = () => {
  return (
    <RequireAuth>
      <RequireBuyerRole>
        <RequireOnboarding>
          <Outlet />
        </RequireOnboarding>
      </RequireBuyerRole>
    </RequireAuth>
  );
};

const RequireBuyerRole: FC<PropsWithChildren> = ({ children }) => {
  const user = useUser();
  const isStaff = user.is_staff;

  const userType = user.membership.type;

  if (userType === MembershipWithOrganizationTypeEnum.land_steward) {
    return <Navigate to={paths.landSteward.restrictedAccess} replace />;
  }

  if (userType !== MembershipWithOrganizationTypeEnum.buyer && !isStaff)
    throw new Error(`Expected "${MembershipWithOrganizationTypeEnum.buyer}", but got invalid user type "${userType}"`);

  return <>{children}</>;
};
